export function CaseStudyItemSkeleton() {
  return (
    <div className="w-full md:w-[calc(50%-1.25rem)] xl:w-[calc(33.333%-1.33rem)]">
      <div className="flex flex-col bg-white overflow-hidden w-full rounded-lg shadow-sm border border-secondary-100 skeleton-grid-item">
        {/* Image area */}
        <div className="relative bg-secondary-50 overflow-hidden w-full h-60 xl:h-72">
          <div className="w-full h-full skeleton-item"></div>
        </div>

        {/* Content area */}
        <div className="flex flex-col gap-3 items-start p-3">
          {/* Tags row */}
          <div className="flex gap-2">
            <div className="w-16 h-5 skeleton-item rounded"></div>
            <div className="w-20 h-5 skeleton-item rounded"></div>
          </div>

          {/* Title */}
          <div className="w-3/4 h-5 skeleton-item rounded"></div>

          {/* Description */}
          <div className="w-full h-4 skeleton-item rounded"></div>
          <div className="w-5/6 h-4 skeleton-item rounded"></div>
        </div>
      </div>
    </div>
  );
}
